/***
 * @file:
 * @author: haoxianhuan
 * @Date: 2021-08-05 10:11:07
 */
import { Component, EventEmitter, forwardRef, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SettingsService } from '@ithinkdt/shared/browser';
import { DictionaryService } from '@ithinkdt/shared/dict';
import { values } from 'lodash';
import * as moment_ from 'moment';
import monitor from '../monitor';
const moment = moment_;
@Component({
  selector: 'dt-table-item',
  templateUrl: './table-item.component.html',
  styleUrls: ['./table-item.component.scss'],
})
export class TableItemComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  set tableData(list: any[]) {
    if (Array.isArray(list)) {
      this.tableList = (list || []).slice();
      this.tableSource = list || [];
      this.createTableIndex();
      this.setForm(this.tableList);
      // setTimeout(()=>)
    }
  }
  @Input() operationWidth: string;
  @Input() isCreate = false;
  @Input() name: string;
  @Input() controls = [];
  @Input() hasDelete = false;
  @Input() scrollY = '';
  @Input() scrollX = '';
  tableSource = [];
  dicts = [];
  bodyHeads = [];
  requireMap = {};
  isMultiHead = false; // æ¯å¦æ¯å¤ç»´è¡¨å¤´
  @Input() set head(heads: any[]) {
    heads = heads || [];
    let colspanHeads = [];
    // å¤ç»´è¡¨å¤´çæåµ
    if (Array.isArray(heads[0]) && Array.isArray(heads[1])) {
      const firstHead = heads[0].slice();
      const lastHead = heads[1].slice();
      colspanHeads = this.mergeMultiHeads(firstHead, lastHead, heads).map((i) => {
        if (i.dictCode && !this.dicts.includes(i.dictCode)) {
          this.dicts.push(i.dictCode);
        }
        if (i.visibility === false) {
          return i;
        } else {
          i.visibility = true;
          return i;
        }
      });
      this.isMultiHead = true;
    }

    this.heads = heads || [];
    if (!Array.isArray(heads[0]) && typeof heads[0] === 'object') {
      this.heads = heads.map((i) => {
        if (i.dictCode && !this.dicts.includes(i.dictCode)) {
          this.dicts.push(i.dictCode);
        }
        if (i.visibility === false) {
          return i;
        } else {
          i.visibility = true;
          return i;
        }
      });
    }
    this.bodyHeads = colspanHeads.length > 0 ? colspanHeads : this.heads;
    if (Array.isArray(this.bodyHeads)) {
      this.bodyHeads
        .map((i) => {
          if (i.visibility === false) {
            return i;
          } else {
            i.visibility = true;
            return i;
          }
        })
        .forEach((i) => {
          if (i.type && i.type !== 'text') {
            this.formControls[i.key] = i;
          }
        });
      this.setForm(this.tableList);
    }
    this.setDict();
  }
  @Output() valueChange = new EventEmitter<any>();
  @Output() tableAfterClick = new EventEmitter<any>();
  @Output() tableBeforeClick = new EventEmitter<any>();
  @Output() tableItemClick = new EventEmitter<any>();
  heads: any[] = [];
  validateForm: FormGroup;
  tableList = [];
  formControls = {};
  dictConf: any;
  dictMap = {};
  constructor(private fb: FormBuilder, private settingsSrv: SettingsService, private dictSrv: DictionaryService) {
    this.dictConf = this.settingsSrv.userConfig['pages'].dictConf || {};
    this.validateForm = this.fb.group({});
    this.validateForm.reset();
  }

  ngOnInit() {
    monitor.on('form-validate', () => {
      return {
        bindKey: 'table',
        validate: this.validator(),
      };
    });
  }
  ngOnDestroy(): void {
    this.validateForm.reset();
  }
  ngOnChanges(changes): void {
    if (changes['formData']) {
    }
  }
  setVisibility(item) {
    if (item.visibility === false) {
      return item;
    }
    item.visibility = true;
    return item;
  }
  /**
   * åå¹¶å¤ç»´æ°ç»
   * @param firstHeads ç¬¬ä¸é¡¹
   * @param secondHeads  ç¬¬äºé¡¹
   * @param heads å»é¤ç¬¬ä¸é¡¹åç
   */
  mergeMultiHeads(firstHeads, secondHeads, heads) {
    let colspanHeads = [];
    const len = heads.length;
    firstHeads.forEach((i) => {
      i = this.setVisibility(i);
      if (i.colspan > 1 && (i.rowspan < len || !i.rowspan) && secondHeads.length) {
        let colspan = i.colspan;
        while (secondHeads.length && colspan > 0) {
          const _colspan = secondHeads[0].colspan;
          secondHeads[0] = this.setVisibility(secondHeads[0]);
          colspanHeads.push(secondHeads[0]);
          secondHeads = secondHeads.slice(1);
          colspan = colspan - _colspan;
        }
      } else {
        colspanHeads.push(i);
      }
    });
    heads = heads.slice(1);
    if (Array.isArray(heads[1])) {
      colspanHeads = colspanHeads.concat(this.mergeMultiHeads(colspanHeads, heads[1], heads));
    }
    return colspanHeads;
  }
  createTableIndex() {
    const cache = [];
    this.tableList.forEach((i, index) => {
      if (i._tableIndex === undefined) {
        if (index === 0) {
          this.tableList[index]._tableIndex = 0;
        } else {
          this.tableList[index]._tableIndex = cache[index - 1] + 1;
        }
      }
      cache[index] = i._tableIndex;
    });
  }
  // tslint:disable-next-line:no-shadowed-variable
  onValueChange(head, index, value) {
    if (head.type === 'datePicker') {
      value = moment(value).format('YYYY-MM-DD');
    }
    if (head.required && head.type && head.type !== 'text' && !head.disabled) {
      let isError = false;
      if (Array.isArray(value) && !value.length) {
        isError = true;
      } else if (!Array.isArray(value) && !value) {
        isError = true;
      }
      this.requireMap[head.key + '&' + this.tableSource[index]._tableIndex] = isError;
    }
    // const item = head[index]
    this.tableSource[index][head.key] = value;
    this.valueChange.emit({ head, index, value, tableData: this.tableList, name: this.name });
  }
  validator() {
    const isRequireObj = {};
    this.requireMap = {};
    const controls = {};
    if (Array.isArray(this.controls)) {
      this.controls.forEach((co: any) => {
        controls[co.row] = co;
      });
    }
    this.bodyHeads.forEach((i) => {
      if (i.required && i.type && i.type !== 'text' && !i.disabled && i.visibility !== false) {
        isRequireObj[i.key] = true;
      }
    });

    this.tableSource.forEach((i, index) => {
      Object.keys(i).forEach((key) => {
        if (typeof i[key] === 'string') {
          i[key] = i[key].trim();
        }
        let colKey = true;
        let colDisabled = false;
        if (controls[index]) {
          colKey = controls[index].controlKeys;
          if (Array.isArray(colKey)) {
            colKey = colKey.includes(key);
          }
          colDisabled = controls[index].control && controls[index].control.disabled;
        }
        if (isRequireObj[key] && !colDisabled && colKey) {
          let isError = false;
          if (Array.isArray(i[key]) && !i[key].length) {
            isError = true;
          } else if (!Array.isArray(i[key]) && !i[key]) {
            isError = true;
          }
          this.requireMap[key + '&' + i._tableIndex] = isError;
        }
      });
    });
    return !values(this.requireMap).some((i) => !!i);
  }
  create() {
    const col = this.tableList[this.tableList.length - 1];
    const newCol = {};
    if (col) {
      Object.keys(col).forEach((i) => {
        newCol[i] = void 0;
      });
      this.tableList = [...this.tableList, newCol];
      // this.tableList.push(newCol);
      this.createTableIndex();
      this.tableSource.push(this.tableList[this.tableList.length - 1]);
      this.setForm(this.tableList);
      this.valueChange.emit({ tableData: this.tableList, name: this.name });
    }
  }
  // æ°å¢è¡¨åæ§ä»¶
  registerFormControl(prop, value = null, disabled = false, validators = []) {
    if (this.validateForm.get(prop)) {
      this.validateForm.controls[prop].setValue(value);
      this.validateForm.controls[prop].setValidators(validators || []);
      if (disabled) {
        this.validateForm.controls[prop].disable();
      } else {
        this.validateForm.controls[prop].enable();
      }
    } else {
      this.validateForm.registerControl(prop, new FormControl({ value, disabled }, validators));
    }
  }
  analysisConf(conf) {
    const { prop, value, validators, disabled } = conf;
    this.registerFormControl(prop, value, disabled, validators);
  }
  setForm(tableData) {
    const headKeys = Object.keys(this.formControls);
    if (Array.isArray(tableData) && headKeys.length) {
      tableData.forEach((i, index) => {
        headKeys.forEach((key) => {
          const conf = {
            prop: key + '&' + i._tableIndex,
            value: i[key],
            validators: this.formControls[key] && this.formControls[key].validators,
            disabled: this.formControls[key] && this.formControls[key].disabled,
          };
          this.analysisConf(conf);
        });
      });
      this.controlConfig();
    }
  }
  removeControl(index) {
    Object.keys(this.tableList[index]).forEach((key) => {
      if (this.validateForm.get(key + '&' + this.tableList[index - 1]._tableIndex)) {
        this.validateForm.removeControl(key + '&' + this.tableList[index - 1]._tableIndex);
      }
    });
  }
  delete(index) {
    const list = this.tableList.slice();
    if (list.length > 1) {
      this.tableList.splice(index, 1);
      this.valueChange.emit({ tableData: this.tableList, name: this.name });
      this.removeControl(index);
      this.setForm(this.tableList);
    }
  }
  setDict() {
    const dicts = this.dicts;
    Promise.all(dicts.map((i) => this.setList(i))).then(() => {
      if (this.bodyHeads.length) {
        this.bodyHeads = this.bodyHeads.map((i) => {
          if (Array.isArray(this.dictMap[i.dictCode])) {
            i.options = this.dictMap[i.dictCode];
            i.list = this.dictMap[i.dictCode];
          }
          return i;
        });
      }
    });
  }
  setList(code: string) {
    return new Promise((r, j) => {
      if (!code) {
        j();
        return;
      }
      this.dictSrv.getDicListByDicCode(code).subscribe((res: any) => {
        if (res.status && res.data) {
          const list = [];
          const parseLable = this.dictConf.label;
          const parseValue = this.dictConf.value;
          res.data.forEach((i) => {
            list.push({
              value: i[parseValue],
              label: i[parseLable],
              disabled: false,
              checked: false,
            });
          });
          // this.list = list;
          this.dictMap[code] = list;
          r(list);
        }
      });
    });
  }
  changeValue(index, data) {
    this.tableList[index] = data;
    Object.keys(data).forEach((key) => {
      const conf = {
        prop: key + '&' + data._tableIndex,
        value: data[key],
        validators: this.formControls[key] && this.formControls[key].validators,
        disabled: this.formControls[key] && this.formControls[key].disabled,
      };
      this.analysisConf(conf);
    });
    // this.setForm(this.tableList);
  }

  // tslint:disable-next-line:no-shadowed-variable
  beforeClick(head, index) {
    this.tableBeforeClick.emit({
      prop: head[index],
      value: this.tableList[index],
      head,
      changeValue: this.changeValue.bind(this, index),
    });
  }
  // tslint:disable-next-line:no-shadowed-variable
  afterClick(head, index) {
    this.tableAfterClick.emit({
      prop: head[index],
      value: this.tableList[index],
      head,
      changeValue: this.changeValue.bind(this, index),
    });
  }
  // tslint:disable-next-line:no-shadowed-variable
  tableClickItem(head, index, value) {
    if (head.click) {
      this.tableItemClick.emit({
        prop: head[index],
        value,
        head,
        changeValue: this.changeValue.bind(this, index),
      });
    }
  }
  // åå¹¶ååæ ¼
  mergeCell() {
    const cells = [
      { row: 0, col: 0, key: 'name', rowspan: 2, colspan: 1 },
      { row: 0, col: 1, key: 'col', rowspan: 2, colspan: 1 },
    ];
    // è·åæ¸é¤çååæ ¼
  }
  // æ§å¶æ¯ä¸è¡æ¯é¡¹çè¡¨å
  controlConfig() {
    // const controls = [
    //   {
    //     // head key
    //     key: 'name',
    //     // head key å¯¹åºçå¼æ¶è§¦å
    //     value: 'Edward King 2',
    //     // å¯¹åºåæ¶è§¦å
    //     row: 1,
    //     controlKeys: [], // true, ['key1', 'key2'],
    //     control: {
    //       disbled: true,
    //       required: false,
    //       hide: false,
    //     },
    //   },
    // ];
    const controls = this.controls;
    if (Array.isArray(controls) && controls.length) {
      const tableList = this.tableList.slice();
      if (Array.isArray(tableList)) {
        tableList.forEach((i, colIndex) => {
          // tslint:disable-next-line:prefer-for-of
          for (let index = 0; index < controls.length; index++) {
            const element = controls[index];
            if (
              ((i[element.key] && i[element.key] === element.value) || element.row === colIndex) &&
              element.controlKeys
            ) {
              this.setItemControl(element.control, index, i, element.controlKeys);
            }
          }
        });
      }
    }
  }
  setItemControl(control, index, item, controlKeys) {
    if (Array.isArray(controlKeys)) {
      controlKeys.forEach((i) => {
        if ((item || {}).hasOwnProperty(i)) {
          const prop = i + '&' + item._tableIndex;
          this.setControl(prop, control);
        }
      });
    } else {
      if (control.hide) {
        this.tableList.splice(index, 1);
      } else {
        const bodyHeads = this.bodyHeads.slice();
        bodyHeads.forEach((i) => {
          const prop = i.key + '&' + item._tableIndex;
          if (i.type && i.type !== 'text' && i.type !== 'table_index') {
            this.setControl(prop, control);
          }
        });
      }
    }
  }
  setControl(prop, control) {
    if (this.validateForm.controls[prop]) {
      if (control.validators) {
        this.validateForm.controls[prop].setValidators(control['validators'] || []);
      }
      if ((control || {}).hasOwnProperty('disabled')) {
        const disabled = control.disabled;
        if (disabled) {
          this.validateForm.controls[prop].disable();
        } else {
          this.validateForm.controls[prop].enable();
        }
      }
    }
  }
  getShowSuffix(data, showReg) {
    if (typeof showReg === 'string' && showReg) {
      return new Function('data', `return (${showReg})`)(data);
    }
    return true;
  }
}

/**
 * [{
 *   title: 'éªè¯äºº',
 *   dataIndex: 'verifyPerson',
 *   key: 'verifyPerson',
 *   type: 'input',
 *   disabled: true,
 *   maxlength: 50,
 *   placeholder: 'è¯·è¾å¥',
 *   after: { icon: 'plus-circle', label: 'Select Personnel', width: '90px' , showReg: 'data.key1 === '1''},
 *   before: { icon: 'plus-circle', label: 'Select Personnel', width: '90px' , showReg: 'data.hasChildren'},
 * }]
 */
